export const cn = {
  joinUs: '加入我们',
  apply: '即刻链接',
  memberName: '全球货代',

  name: '姓名',
  country: '国家/区域',
  countryCity: '所在地（城市）',
  company: '公司名称',
  companyChinese: '公司中文名称',
  eMail: '邮箱',
  tel: '电话',
  jobTitle: '职位',
  validatorName: '请填写您的姓名全称',
  validatorName1: '姓名全称不能超过128个字符',
  validatorName2: '姓名全称不能包括中文',
  validatorCountry: '请选择您的国家/区域',
  validatorCountryCity: '请选择您的所在地',
  validatorCompany: '请填写您的公司全称',
  validatorCompany1: '公司名称为2-200个字符',
  validatorCompany2: '公司英文名称不能包括中文',
  validatorCompanyChinese: '请填写您的公司中文名称',
  validatorCompanyChinese1: '公司中文名称为2-200个字符',
  validatorCompanyEMail: '请填写您的企业邮箱',
  validatorCompanyEMail1: '邮箱不能超过90个字符',
  validatorCompanyEMail2: '当前不支持qq邮箱，请更换其他邮箱',
  validatorCompanyTel: '请填写您的电话',
  validatorCompanyTel1: '手机号必须为数字，不能超过11个字符且少于8个字符',

  validate_email: '请填写您的公司邮箱',
  validate_tel: '请填写您的电话',
  validateJobTitle: '请选择您的职位',

  ok: '好',
  success: '提交成功',
  verifyTitle: '请完成安全验证',
  verifyMessage: '向右滑动完成验证',
}

export const en = {
  joinUs: 'Join Us',
  apply: 'Apply for ',
  memberName: 'JCtrans membership',

  name: 'Your Name',
  country: 'Country/Region',
  countryCity: 'Location(City)',
  company: 'Company Name',
  companyChinese: 'Company Name In Chinese',
  eMail: 'Email',
  tel: 'Tel',
  jobTitle: 'Job Title',
  validatorName: 'Please fill in your full name',
  validatorName1: 'Your name cannot exceed 128 characters',
  validatorName2: 'Do not include Chinese characters in your name',
  validatorCountry: 'Please select your Country or Region',
  validatorCountryCity: 'Please select your location',
  validatorCompany: 'Please fill in your company name',
  validatorCompany1: 'Company name must be at 2-200 characters',
  validatorCompany2: 'Do not include Chinese characters in company name',
  validatorCompanyChinese: 'Please fill in your company name in Chinese',
  validatorCompanyChinese1:
    'Company name in Chinese must be at 2-200 characters',
  validatorCompanyEMail: 'Please fill in your corporate email',
  validatorCompanyEMail1: 'Email cannot exceed 90 characters',
  validatorCompanyEMail2:
    'QQ mailbox is not available, please change to another mailbox.',
  validatorCompanyTel: 'Please fill in your tel',
  validatorCompanyTel1:
    'Tel must be numbers, cannot exceed 11 characters and less than 8 characters',
  validate_email: 'Please fill in your corporate email',
  validate_tel: 'Please fill in your tel',
  validateJobTitle: 'Please select your job title',

  ok: 'ok',
  success: 'Submit successfully!',
  verifyTitle: 'Please finish the security verification',
  verifyMessage: 'Swipe right to complete the picture puzzle',
}
